import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/index.tsx';
import { dashboardsDirectoryResource } from '@atlassian/jira-router-resources-directories-dashboards/src/services/dashboards-directory/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { dashboardsDirectoryRoute } from '@atlassian/jira-router-routes-directories-routes/src/dashboardsDirectoryRoute.tsx';
import { DashboardsDirectorySkeleton } from '@atlassian/jira-skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { nav4SidebarContentCoreEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-core/entrypoint.tsx';
import { nav4DashboardsContentEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-dashboards/src/ui/dashboards/default/async-content/entrypoint.tsx';
import { dashboardDirectoryEntryPoint } from '@atlassian/jira-spa-apps-directories-dashboards/entrypoint.tsx';
import { DashboardsDirectoryComponent, LazyDashboardsDirectory } from './ui/dashboards/index.tsx';

export const dashboardsDirectoryRouteEntry = createEntry(dashboardsDirectoryRoute, () => ({
	group: 'directories',
	component: DashboardsDirectoryComponent,
	entryPoint: pageEntryPoint,
	skeleton: DashboardsDirectorySkeleton,
	layout: globalLayout,
	resources: [...getNavigationResources(), dashboardsDirectoryResource],

	navigation: {
		menuId: MENU_ID.DASHBOARDS,
		sidebarId: SIDEBAR_ID.CONTENT, // Nav4
	},

	forPaint: [LazyAtlassianNavigation, LazyDashboardsDirectory],
}));

// Page entrypoint, referred to above...
const pageEPConfigOld = createPageEntryPoint({
	main: dashboardDirectoryEntryPoint,
	topNavigationMenuId: MENU_ID.DASHBOARDS,
	leftSidebar: {
		sidebar: nav4SidebarContentCoreEntryPoint,
		entryPoints: {},
		// Temporary, until we can remove the *Landing components from the Nav4 sidebar
		isDashboardsExpanded: true,
	},
});

const pageEPConfigNew = createPageEntryPoint({
	main: dashboardDirectoryEntryPoint,
	topNavigationMenuId: MENU_ID.DASHBOARDS,
	leftSidebar: {
		sidebar: nav4SidebarContentCoreEntryPoint,
		entryPoints: {
			dashboards: {
				entryPoint: nav4DashboardsContentEntryPoint,
			},
		},
		// Temporary, until we can remove the *Landing components from the Nav4 sidebar
		isDashboardsExpanded: true,
	},
});

function pageEntryPoint() {
	if (fg('blu-6923-dashboard-entry-points')) {
		if (fg('blu-6923-nav4-dashboard-ep-support')) {
			return pageEPConfigNew;
		}
		return pageEPConfigOld;
	}
	return undefined;
}
